export default __webpack_public_path__ + "static/media/GoBackIcon.10c30781.svg";